import { SelectOption } from '~globals/types/commons';
import { RevisitExhaustedReasonType } from '~globals/types/enums';

export const MAX_REVISIT = 10;

export const REVISIT_EXHAUSTED_REASON_OPTIONS: SelectOption[] = [
  {
    value: RevisitExhaustedReasonType.ReportDriver,
    label: 'El que informó el chofer',
  },
  {
    value: RevisitExhaustedReasonType.RejectedReason,
    label: 'Uno de la lista de motivos de rechazo',
  },
  {
    value: RevisitExhaustedReasonType.Custom,
    label: 'Un texto personalizado',
  },
];

export const validateExhaustedReasonType = (
  currentType: RevisitExhaustedReasonType,
  comparatorType: RevisitExhaustedReasonType,
): boolean => currentType === comparatorType;
